/* eslint-disable react/self-closing-comp */
import React from "react";
import "./PrivacyPolicyPage.scss";
import { Page } from "components/core/Page";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import Table from "components/sdc/PrivacyPolicy/Table";
import {
	Heading,
	Description,
	ListPoint,
	SmallSearchBar,
	CustomDecimalPoint,
	BorderLine,
	PRIVACY_POLICY_DATA,
	TABLE_DATA_1,
	TABLE_HEADINGS_1,
	TABLE_DATA_2,
	TABLE_HEADINGS_2
} from "components/sdc/PrivacyPolicy";
import { Heading as H1 } from "components/storages/Common";
import { useSelector } from "react-redux";

function PrivacyPolicyPage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	return (
		<Page
			title="Privacy Policy and Storage Units, Mini Storage, Business Storage at Storage.com"
			description=""
			canonical={`${baseUrl}/about-us/privacy/`}
		>
			<Container>
				<div className="sdc-page-container">
					<div className="first-col">
						<H1
							content="Storage.com Privacy Policy"
							size="xxlarge"
						/>
						{PRIVACY_POLICY_DATA.map((item) => (
							<>
								<br />
								<Heading
									content={item.heading}
									color={item.headingColor}
								/>
								<Description {...item} />
								{/* <br /> */}
								{item.points?.map((point) => (
									<>
										{point.descLink ? (
											<ListPoint
												descLink={point.descLink}
											/>
										) : (
											<ListPoint desc={point} />
										)}
									</>
								))}
								{item.customPoints?.map((point, index) => (
									<CustomDecimalPoint
										point={point}
										index={index}
									/>
								))}
								{item.table1 && (
									<>
										<Table
											tableHeadings={TABLE_HEADINGS_1}
											tableData={TABLE_DATA_1}
										/>
										<br />
									</>
								)}
								{item.table2 && (
									<>
										<Table
											tableHeadings={TABLE_HEADINGS_2}
											tableData={TABLE_DATA_2}
										/>
										<br />
									</>
								)}
							</>
						))}
					</div>
					<BorderLine />
					<div className="second-col">
						<SmallSearchBar />
					</div>
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default PrivacyPolicyPage;
